export function CTA() {
  return (
    <section
      className="py-32 bg-gray-50 text-center"
      aria-label="Call to Action"
    >
      <div className="max-w-3xl mx-auto px-4">
        <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter mb-6 text-gray-900">
          Ready to Secure Your Supply?
        </h2>
        <p className="text-xl text-gray-600 font-medium mb-10">
          Don&apos;t wait until the storm hits or the project deadline looms.
          Get in touch with our dispatch team today.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <a
            className="bg-salt-orange text-white px-10 py-5 rounded-md font-black uppercase tracking-widest hover:bg-orange-600 transition-colors shadow-xl text-sm"
            href="/"
          >
            Request Sourcing
          </a>
          <a
            href="tel:8884910911"
            className="bg-white text-salt-dark border-2 border-salt-dark px-10 py-5 rounded-md font-black uppercase tracking-widest hover:bg-salt-dark hover:text-white transition-colors shadow-xl text-sm"
          >
            Call (888) 491-0911
          </a>
        </div>
      </div>
    </section>
  );
}
